<app-modal>
  <ng-container modal-header>
    <h5 class="modal-title">{{ 'service.tickets.details.approveReport.title' | translate }}</h5>
  </ng-container>

  <div class="modal-body" modal-body>
    <app-scroll-list-item
      index="0"
      leftIcon="fa-paper-plane"
      text="blue-text"
      title="{{ 'service.tickets.details.approveReport.sendToOwner' | translate }}"
      [selected]="isSelected(reportStatus.SendingToOwner)"
      (click)="onSelectOption(reportStatus.SendingToOwner)">
    </app-scroll-list-item>

    <app-scroll-list-item
      index="1"
      leftIcon="fa-check"
      text="green-text"
      title="{{ 'service.tickets.details.approveReport.resolvedInternally' | translate }}"
      [selected]="isSelected(reportStatus.ResolvedInternally)"
      (click)="onSelectOption(reportStatus.ResolvedInternally)">
    </app-scroll-list-item>

    <div class="reason-form-wrapper" [class.visible]="showReason">
        <form [formGroup]="form" class="reason-form">
            <app-textarea
            [formControl]="control('description')"
            [showErrors]="showValidations"
            [maxLength]="120"
            label="{{ 'service.tickets.details.approveReport.descriptionLabel' | translate }}"
            placeholder="{{ 'service.tickets.details.approveReport.descriptionPlaceholder' | translate }}">
            </app-textarea>
        </form>
    </div>
  </div>

  <div class="footer" modal-footer>
    <app-button type="simple" (clicked)="onCancel()">
      {{ 'generic.buttons.cancel' | translate }}
    </app-button>
    <app-button type="primary" (clicked)="onConfirm()">
      {{ 'generic.buttons.confirm' | translate }}
    </app-button>
  </div>
</app-modal>
